import type { AppointmentStatus } from '@agenda-facil/contracts';

export const appointmentStatusLabel: Record<AppointmentStatus, string> = {
  PENDING: 'Pendente',
  CONFIRMED: 'Confirmado',
  CHECKED_IN: 'Chegou',
  IN_SERVICE: 'Em atendimento',
  COMPLETED: 'Concluído',
  CANCELED: 'Cancelado',
  NO_SHOW: 'Falta',
};

export const appointmentStatusTone: Record<
  AppointmentStatus,
  'neutral' | 'success' | 'warning' | 'danger'
> = {
  PENDING: 'warning',
  CONFIRMED: 'success',
  CHECKED_IN: 'warning',
  IN_SERVICE: 'warning',
  COMPLETED: 'neutral',
  CANCELED: 'danger',
  NO_SHOW: 'danger',
};

export const appointmentStatusClass: Record<AppointmentStatus, string> = {
  PENDING:
    'border-[color-mix(in_srgb,var(--accent)_32%,var(--border))] bg-[var(--accent-soft)] text-[var(--accent)]',
  CONFIRMED:
    'border-[color-mix(in_srgb,var(--success)_32%,var(--border))] bg-[var(--success-soft)] text-[var(--success)]',
  CHECKED_IN:
    'border-[color-mix(in_srgb,var(--accent)_32%,var(--border))] bg-[var(--accent-soft)] text-[var(--accent)]',
  IN_SERVICE:
    'border-[color-mix(in_srgb,var(--warning)_34%,var(--border))] bg-[var(--warning-soft)] text-[var(--warning)]',
  COMPLETED: 'border-[var(--border)] bg-[var(--surface-raised)] text-[var(--foreground)]',
  CANCELED:
    'border-[color-mix(in_srgb,var(--danger)_28%,var(--border))] bg-[var(--danger-soft)] text-[var(--danger)] opacity-80',
  NO_SHOW:
    'border-[color-mix(in_srgb,var(--danger)_22%,var(--border))] bg-[color-mix(in_srgb,var(--danger-soft)_60%,var(--surface))] text-[var(--danger)] opacity-75',
};
